import moment from "moment";
import "moment/locale/cs";

export const formatDate = (cell, row) => {
	return cell ? moment(cell).format('D.M.YYYY') : ''
};

export const formatDateSimple = (cell, row) => {
	return cell ? moment(cell).format('D.M.') : ''
};

export const formatDateTime = (cell, row) => {
	if (!cell) {
		return ''
	}
	let f = moment(cell).format('D.M.YYYY HH:mm');
	return f.replace(" 00:00", "")
};

export const formatTime = (cell, row) => {
	if (!cell) {
		return ''
	}
	return moment(cell).format('HH:mm:ss');
};

export const parseDate = (v) => {
	if (!v) {
		return null
	}
	if (v instanceof Date) {
		return moment(v).format('YYYY-MM-DD')
	}
	if (v.length > 10) {
		v = v.substring(0, 10)
	}
	return new Date(v)
};

export const extractTime = (v) => {
	if (!v) {
		return null
	}
	if (v instanceof Date) {
		return v.getHours() + ":" + v.getMinutes() + ":" + v.getSeconds()
	}
	if (v.length > 8) {
		v = v.substring(v.length - 8)
	}
	return v
};

export const today = (session) => {
	let now = new Date();
	if (session && session.user && session.user.configuration) {
		now = moment(session.user.configuration.today).toDate()
	}
	return now
};

export const currentTS = () => Math.floor(Date.now() / 1000);


// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/components/utils/date.js